import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Menu } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  // Handle responsive behavior
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsSidebarExpanded(false);
        setIsMobile(true);
      } else {
        setIsSidebarExpanded(true);
        setIsMobile(false);
      }
    };
    // Initial check
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const toggleSidebar = () => setIsSidebarExpanded(!isSidebarExpanded);
  return <div className="min-h-screen bg-background text-text-primary flex" data-id="element-126">
      {/* Sidebar */}
      <Sidebar isExpanded={isSidebarExpanded} toggleSidebar={toggleSidebar} data-id="element-127" />

      {/* Main Content */}
      <main className={`flex-1 transition-all duration-300 min-h-screen flex flex-col ${isSidebarExpanded ? 'ml-[240px]' : 'ml-[72px]'}`} data-id="element-128">
        {/* Mobile Header (only visible on small screens) */}
        <div className="lg:hidden h-16 border-b border-white/5 flex items-center px-4 bg-background sticky top-0 z-40" data-id="element-129">
          <button onClick={toggleSidebar} className="p-2 -ml-2 text-text-secondary" data-id="element-130">
            <Menu size={24} data-id="element-131" />
          </button>
          <span className="ml-3 font-bold text-lg" data-id="element-132">Collina</span>
        </div>

        {/* Page Content */}
        <div className="flex-1 p-4 md:p-6 lg:p-8 overflow-x-hidden" data-id="element-133">
          <div className="max-w-[1600px] mx-auto" data-id="element-134">{children}</div>
        </div>
      </main>
    </div>;
}